import { PEOPLE_DIRECTORY_PATH, STAFF_DIRECTORY_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const embeddableDirectoryRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: STAFF_DIRECTORY_PAGE,
	path: `${PEOPLE_DIRECTORY_PATH}/:search(search)?/:teams(teams)?`,
	subproduct: 'townsquare-people-team-directory',
});
